<template>
  <div>
    <div
      class="comment-view-tabs"
      role="group"
    >
      <button
        type="button"
        class="comment-view-tab"
        :aria-pressed="showPostComments"
        @click="showPostComments = true"
      >
        {{ commentWords.title }}
      </button>
      <button
        type="button"
        class="comment-view-tab"
        :aria-pressed="!showPostComments"
        @click="showPostComments = false"
      >
        {{ commentWords.legacy }}
      </button>
    </div>
    <PostCommentModeration v-if="showPostComments" />
    <div v-else>
      <layout-loading v-if="isSubmit" />
      <changeLanguageHeaderTable
        :current-language="currentLanguage"
        @change-language="changeLanguage"
      />

      <BDataTable
        ref="refTable"
        :fetch-list="fetchList"
        :selectable="false"
        :table-columns="tableColumns"
        :delete-item="false"
        @onGroupDelete="groupDelete"
      >
        <!-- Column: rate -->
        <template #cell(rate)="{ item }">
          <star-rating
            :star-size="17"
            :rating="item.rate"
            read-only
            inactive-color="#535454"
            :show-rating="false"
            rounded-corners
            :padding="2"
          />
        </template>

        <!-- Column: status -->
        <template #cell(status)="{ item }">
          <div class="text-center">
            <feather-icon
              v-if="item.status"
              icon="EyeIcon"
              opacity=".4"
              size="20"
            />
            <feather-icon
              v-else
              icon="EyeOffIcon"
              color="indianred"
              size="20"
            />
          </div>
        </template>

        <!-- Column: report -->
        <template #cell(report)="{ item }">
          <feather-icon
            v-if="item.report"
            icon="AlertTriangleIcon"
            color="#d9791a"
            size="20"
          />
        </template>

        <!-- Column: link -->
        <template #cell(link)="{ item }">
          <a
            :href="item.link"
            target="_blank"
          >
            <feather-icon
              icon="LinkIcon"
              size="22"
              opacity=".8"
            />
          </a>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="{ item }">
          <edit-row @click.native="toEditPage(item._id)" />
        </template>
      </BDataTable>
      <b-modal
        v-model="modalShow"
        hide-header-close
        scrollable
        centered
        hide-footer
        hide-header
        body-class="message-modal"
        no-fade
      >
        <div>{{ modalContent }}</div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import BDataTable from '@/components/BDataTable/index.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import StarRating from 'vue-star-rating'
import changeLanguageHeaderTable from '@/components/change-language-header-table.vue'
import { BModal } from 'bootstrap-vue'
import useCommentList from './useCommentList'
import commentMessages from '../postComment/messages'
import PostCommentModeration from '../postComment/PostCommentModeration.vue'

export default {
  name: 'CommentList',
  components: {
    PostCommentModeration,
    BDataTable,
    BModal,
    EditRow,
    LayoutLoading,
    StarRating,
    changeLanguageHeaderTable,
  },
  setup() {
    const {
      changeLanguage,
      currentLanguage,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    } = useCommentList()

    return {
      changeLanguage,
      currentLanguage,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    }
  },
  data() {
    return {
      showPostComments: true,
      modalShow: false,
      modalContent: '',
    }
  },
  computed: { commentWords() { return commentMessages[this.$i18n.locale] || commentMessages.fa } },
  methods: {
    triggerModal(content) {
      this.modalContent = content
      this.modalShow = !this.modalShow
    },
  },
}
</script>

<style scoped>
.comment-view-tabs { display: flex; gap: 24px; border-bottom: 1px solid #e2e9e9; margin-bottom: 24px; }
.comment-view-tab { font: inherit; font-size: 13px; color: #718187; background: transparent; border: 0; border-bottom: 2px solid transparent; padding: 12px 2px; cursor: pointer; }
.comment-view-tab[aria-pressed='true'] { color: #16757c; border-bottom-color: #4ca8ae; }
.comment-view-tab:focus-visible { outline: 2px solid #1d9199; outline-offset: 3px; }
</style>
